import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {
    Elink, CreateCustomInventoryEstimateUrl, UploadInventoryOrRoomImagesUrl
} from "../CommonComponents/Routes";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import imageCompression from "browser-image-compression";
import {Modal} from "react-bootstrap";
import {Animation} from "./Animation";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

const CustomItemPage = (props) => {
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    const Room = RecordController.Room
    const [CustomItemName, SetCustomItemName] =useState('');
    const [CustomItemCuft, SetCustomItemCuft] =useState('');
    const [CustomItemLbs, SetCustomItemLbs] =useState('');
    const [CustomItemMovingTime, SetCustomItemMovingTime] =useState('');
    const [CustomItemQty, SetCustomItemQty] =useState('');
    const [InventoryImage, SetInventoryImage] =useState({});
    const [imageModal, setimageModal] = useState("");
    const [Loader, SetLoader] = useState(false);
    const [modal, SetModal] = useState(false);
    const [UploadImage, SetUploadImage] = useState(true);
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;
    useEffect(()=>{
        if(RecordController.Click){
            Animation("custom-item-page",RecordController.Click);}
    },[])
    const zoomImage = (image) => {//used for adding the feature of zoom in to the image
        setimageModal(image.replace("thumb", "medium"));
        SetModal(true);
    }

    const handleModal = () => {
        SetModal(false);
        setimageModal('');
    }

    const ValidateInputs =   (device_type) => { // add required field to last empty field
        let element = document.getElementsByClassName("required-field-value")
        for ( let i = 0; i < element.length; i++) {
            if(element[i]["id"] === device_type) {
                if (element[i]["value"] === "") {
                    element[i].setAttribute('style', 'border: 2px solid red');
                    return false
                }
                element[i].setAttribute('style', 'border: 2px solid none');
            }
        }
    }


    const RevertInputBorder = (device_type) => { // remove the required for other fields except last empty
        let element = document.getElementsByClassName("required-field-value")
        for (let i = 0; i < element.length; i++) {
            if(element[i]["id"] === device_type) {
                element[i].setAttribute('style', 'border: 2px solid none');
            }
        }
    }

    const AddCustomItem = async ( device_type) => {
        RevertInputBorder(device_type); // check validation of last empty input
        let checkValidation = await ValidateInputs(device_type) // check validations for all inputs
        if (checkValidation === undefined) {
            SetLoader(true);
            axios({//post request is send to the "update_inventories" function for creating custom inventory.
                method: 'post',
                url: CreateCustomInventoryEstimateUrl,
                data: {
                    estimate_key: Elink,
                    default_room_estimate_id: Room.Id,
                    inventory_hash: {
                        inven_name: CustomItemName, inven_volume: CustomItemCuft, inven_weight: CustomItemLbs,
                        inven_moving_time: CustomItemMovingTime, inven_qty: CustomItemQty
                    }
                }
            }).then((response) => {// update the page content
                let inventoryId = response.data.InventoryId
                try {
                    if (InventoryImage){
                        axios({
                            method: 'post',
                            url: UploadInventoryOrRoomImagesUrl,
                        data: {
                            estimate_key: Elink,
                            image_files: InventoryImage,
                            picture_type: "Custom Inventory",
                            inventory_id: inventoryId,
                            capture_image: RecordController.CaptureImage
                        }
                        }).then(async response => {
                            await SetLoader(false);
                            await RecordController.SetClick('next');
                            await AnimationPrevious ( "next-go",  "custom-item-page",  "MOBILE_ROOM_DETAIL", PageView);
                            await RecordController.SetCaptureImage("");
                        })
                    }
                    else {
                        SetLoader(false);
                        RecordController.SetClick('next')
                        AnimationPrevious("next-go", "custom-item-page", "MOBILE_ROOM_DETAIL", PageView);
                    }

                } catch (error) {
                    console.log(error);
                }
            })
        }

    }
    const BackToAddInventories =()=>{ // back to add inventories page
        RecordController.SetClick('back');
        AnimationPrevious("back-go", "custom-item-page", "ADD_INVENTORIES", PageView);
    }

    const getFile = async (file) => { // this component is used to get files having allowed extensions ( ["jpg", "jpeg", "gif", "png"])
        let b = []
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        let allowedExtension = ["jpg", "jpeg", "gif", "png", "JPG", "JPEG", "GIF", "PNG"];
        for (let i=0; i < file.length; i++) {
            let extName =  allowedExtension.indexOf(file[i].name.split('.').pop()) > -1
            let message = extName ? file[i].name+ " is not saved, picture quality of "+file[i].name+"  is too low" : file[i].name+ " is not saved, Only image file with extension: .jpg, .jpeg, .gif or .png is allowed"
            if ( extName && file[i].size > 1000){
                const compressedFile = file[i].size > 1000000 ? await imageCompression(file[i], options) : file[i];
                let cp = await toBase64(compressedFile)// compress the image
                b.push(cp)
            }else{
                PageView.setAlertProperty({
                    Message: message,
                    Type: "warning",
                    Show: true,
                    AutoHide: false
                })
            }
        }
        return b;
    }

    const onImageChange =  async (event) => {//save the images and send to the "upload_image" function through post request in "client_portal_controller" to save the images
        let file = event.target !== undefined ? event.target.files : event
        if (file && file.length <= 10) {
            let files = await getFile(file) // it will check the extension and size of the image and if needed it will compress the images
            SetInventoryImage(files);
            SetUploadImage(false);
        }else {//if select images are more than 10 then it will shows the alert message.
            if (event.target !== undefined){
                event.target.value = null;
            }
            PageView.setAlertProperty({
                Message: "You can select up to ten images",
                Type: "warning",
                Show: true,
                AutoHide: true
            })

        }
    }

    const toBase64 = file => new Promise((resolve, reject) => {//encode the images
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const ImageDetail =(props)=>{ // this component is used to show the image and cross tag(for delete the image)
        return(
            <>
                <img style={{margin: "1.5%", borderRadius: "12px", height: "110px", width: "90px"}} onClick={()=> zoomImage(props.image)} data-toggle="modal"
                     data-target="#Modal-2" src={props.image} alt="preview image" className={props.id} />
                <span className={"btn image-cross"} style={{margin: "0rem 0rem 25% -1.5rem"}} onClick={()=>DeleteImage({id: props.id, image: props.Image})}><b>X</b>
                </span>
            </>
        )
    }
    const hiddenFileInput = React.useRef(null);

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    const DeleteImage = (props) =>{
        delete InventoryImage[props.id];
        let element = document.getElementsByClassName(props.id);
        SetInventoryImage(InventoryImage);
        element[0].setAttribute('style','display: none;');
        element[0].nextElementSibling.setAttribute('style','display: none;');
        element[1].setAttribute('style','display: none;');
        element[1].nextElementSibling.setAttribute('style','display: none;');
        if(Object.keys(InventoryImage).length === 0){
            SetUploadImage(true);
        }
    }

    const handleCamera =() => {
        RecordController.SetCameraFrom("Custom");
        RecordController.SetClick("no-class");
        PageView.Set("TAKE_PICTURE");
        SetUploadImage(false);
    }
    const DeleteCaptureImage = () =>{
        RecordController.SetCaptureImage('');
    }

    const addCustomItems = (device_type) => {
        return(
            <>
                <div className="container">
                    <div className="row custom-item-row">
                        <div className="col-sm-1 col-md-2 col-lg-3 col-xl-3">
                            <div className="back-button-display">
                                <button className="btn-st-back" type="submit" onClick={()=> BackToAddInventories()}
                                        style={{borderRadius: "8px", color: GetTextColor(CustomerInvReq.ButtonColor), backgroundColor: CustomerInvReq.ButtonColor}}>Back</button>
                            </div>
                        </div>
                        <div className="col-sm-10 col-md-8 col-lg-7 col-xl-6 " >
                            <div className="header-tx text-center">
                                <div className="arrow-st" onClick={()=> BackToAddInventories()}>
                                    <i className={"fas fa-angle-left"} style={{fontSize: "35px",color: GetTextColor(CustomerInvReq.BackgroundColor)}}></i>
                                </div>
                                <h3 style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>Custom Item</h3>
                            </div>
                        </div>
                        <div className="col-sm-1 col-md-2 col-lg-3 col-xl-3">
                        </div>
                    </div>
                    <div className="text-center section-new-inventories" style={{marginTop: "4.5rem"}}>
                        <div className="row d-flex justify-content-center align-items-center h-100">
                            <div className="col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6">
                                {
                                    Loader ?
                                        <div style={{height: "50vh"}}>
                                            <img src={process.env.PUBLIC_URL + "/Images/Loader18.gif"}
                                             style={{width: "50%", height: "50%"}}/>
                                        </div>
                                        :
                                        <>
                                        <form>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="col-form-label required-field" style={{lineHeight: 1}}>Item
                                                            Name</label>
                                                        <input type="text" className="form-control required-field-value" id={device_type}
                                                               style={{width: "98%"}} value={CustomItemName}
                                                               onChange={(e) => {
                                                                   SetCustomItemName(e.target.value)
                                                               }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    <div className="mb-3">
                                                        <label className="col-form-label required-field" style={{lineHeight: 1}}>CUft</label>
                                                        <input type="text" className="form-control required-field-value" id={device_type}
                                                               style={{width: "98%"}} value={CustomItemCuft}
                                                               onChange={(e) => {
                                                                   SetCustomItemCuft(e.target.value.replace(/\D/g, ""))
                                                               }}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    <div className="mb-3">
                                                        <label className="col-form-label required-field" style={{lineHeight: 1}}>Lbs</label>
                                                        <input type="text" className="form-control required-field-value" id={device_type}
                                                               style={{width: "98%"}} value={CustomItemLbs}
                                                               onChange={(e) => {
                                                                   SetCustomItemLbs(e.target.value.replace(/\D/g, ""))
                                                               }}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    <div className="mb-3">
                                                        <label className="col-form-label required-field" style={{lineHeight: 1}}>Moving
                                                            Time</label>
                                                        <input type="text" className="form-control required-field-value" id={device_type}
                                                               style={{width: "98%"}} value={CustomItemMovingTime}
                                                               onChange={(e) => {
                                                                   SetCustomItemMovingTime(e.target.value.replace(/\D/g, ""))
                                                               }}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-6">
                                                    <div className="mb-3">
                                                        <label className="col-form-label required-field" style={{lineHeight: 1}}>Quantity</label>
                                                        <input type="text" className="form-control required-field-value" id={device_type}
                                                               style={{width: "98%"}} value={CustomItemQty}
                                                               onChange={(e) => {
                                                                   SetCustomItemQty(e.target.value.replace(/\D/g, ""))
                                                               }}/>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="mb-3" style={{height: "19vh", overflow: "scroll"}}>
                                                        {RecordController.CaptureImage ?
                                                            <>
                                                                <img style={{margin: "1.5%", borderRadius: "12px", height: "110px", width: "90px"}}
                                                                     onClick={() => zoomImage(RecordController.CaptureImage)}
                                                                     data-toggle="modal"
                                                                     data-target="#Modal-2"
                                                                     src={RecordController.CaptureImage}
                                                                     alt="preview image"/>
                                                                <span className={"btn image-cross"}
                                                                      style={{color: 'blue', backgroundColor: "#fbfbff", margin: "0rem 0rem 25% -1.5rem"}}
                                                                      onClick={() => DeleteCaptureImage({image: RecordController.CaptureImage})}>X</span>
                                                            </>
                                                            :
                                                            Object.keys(InventoryImage).length > 0
                                                                ?
                                                                Object.entries(InventoryImage).reverse().map(([id, image]) => {
                                                                    return (
                                                                        <ImageDetail image={image} id={id}/>
                                                                    )
                                                                })
                                                                : UploadImage ?
                                                                <div className="dropup dd-button">
                                                                    <h5 data-toggle="dropdown">Upload Image</h5>
                                                                    <ul className="dd-menu dropdown-menu dropup">
                                                                        <li className={'dropdown-item'} onClick={() => handleCamera()}>Take Photo</li>
                                                                        <li className={'dropdown-item'} id="upload-st" onClick={handleClick}>Choose
                                                                            photo from Liberary</li>
                                                                        <input
                                                                            type="file"
                                                                            ref={hiddenFileInput}
                                                                            onChange={onImageChange}
                                                                            style={{display: 'none'}}
                                                                            multiple={true}
                                                                            accept='image/*'
                                                                        />
                                                                    </ul>
                                                                </div> : ''
                                                        }
                                                    </div>
                                                    <Modal className="zoom-image-modal" show={modal} onHide={() => handleModal()}>
                                                        <div className={"modal-header"} style={{backgroundColor: "transparent", padding: "0px",border: 'none'}}>
                                                            <span className={"close btn"} aria-hidden="true" style={{
                                                                margin: "-2.6rem -1.2rem -2rem auto", color: "gray", fontSize: "40px"}}
                                                                  onClick={() => handleModal()}>&times;</span>
                                                        </div>
                                                        <div className={"modal-body"} style={{
                                                            backgroundColor: "transparent",
                                                            padding: '0px'
                                                        }}>
                                                            <img style={{width: "100%", height: "60vh",backgroundColor: "transparent", border: 'none'}}
                                                                 src={imageModal} alt="preview image"/>
                                                        </div>
                                                    </Modal>
                                                </div>
                                            </div>
                                        </form>
                                        <button className="btn btn-st-add mb-4" type="submit" onClick={()=>AddCustomItem(device_type)}
                                                style={{borderRadius: "8px", color: GetTextColor(CustomerInvReq.ButtonColor), backgroundColor: CustomerInvReq.ButtonColor}}>
                                            <b>ADD</b>
                                        </button>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            <section className="item-section-2 desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}>
                <div className={"custom-item-page"} style={{width: "100vw", position: "relative"}}>
                    {addCustomItems("desktop-vw")}
                </div>
            </section>
            <section className="mobile-vw">
                <div className="container-mv">
                    <svg viewBox="0 0 500 500"
                         preserveAspectRatio="xMinYMin meet"
                         style={{zIndex: -1}} id="svg-mv">
                        <path d="M0, 170 C360, 30, 630,
                510 595,-400 L900, 00 L0, 0 Z"
                              style={{stroke: "none",fill: CustomerInvReq.BackgroundColor}}>
                        </path>
                    </svg>

                </div>
                <div className={"custom-item-page"} style={{width: "100vw"}}>
                    {addCustomItems("mobile-vw")}
                </div>
            </section>
        </>
    )
}
export default CustomItemPage;